import FpxVerification from "./pages/FpxVerification";
import ApplicationRejected from "./components/ApplicationRejected";
import Unsubscribe from "./pages/auth/Unsubscribe";

const NotFound = () => import(/* webpackChunkName: "auth" */"./pages/NotFound.vue");

const Login = () => import(/* webpackChunkName: "auth" */'./pages/auth/Login.vue');
const Simulation = () => import(/* webpackChunkName: "auth" */'./pages/Simulation.vue');
const TwoFactorPage = () => import(/* webpackChunkName: "main_app" */"./pages/auth/TwoFactorPage.vue");
const LostAuthenticator = () => import(/* webpackChunkName: "auth" */"./pages/auth/LostAuthenticator.vue");
const Inactive = () => import(/* webpackChunkName: "auth" */'./pages/auth/Inactive.vue');
const Register  = () => import(/* webpackChunkName: "auth" */'./pages/auth/Register.vue');
const ForgotPassword = () => import(/* webpackChunkName: "auth" */"./pages/auth/ForgotPassword.vue");
const VerifiedUser = () => import(/* webpackChunkName: "auth" */"./pages/auth/VerifiedUser.vue");
const PrivacyPolicy = () => import(/* webpackChunkName: "auth" */"./pages/PrivacyPolicy.vue");
const Consent = () => import(/* webpackChunkName: "auth" */"./pages/Consent.vue");
const IssuerDisclosure = () => import(/* webpackChunkName: "auth" */"./pages/IssuerDisclosure.vue");
const TermsAndConditions = () => import(/* webpackChunkName: "auth" */"./pages/TermsAndConditions.vue");
const ApplicationUnderReview = () => import(/* webpackChunkName: "auth" */"./components/ApplicationUnderReview.vue");

const InvestorApplication = () => import(/* webpackChunkName: "application" */"./pages/applications/InvestorApplication.vue");
const BusinessOwnerApplication = () => import(/* webpackChunkName: "application" */"./pages/applications/BusinessOwnerApplication.vue");

const Dashboard = () => import(/* webpackChunkName: "main_app" */"./pages/Dashboard.vue");
const ApplyFinancing = () => import(/* webpackChunkName: "main_app" */"./pages/business_owners/ApplyFinancing.vue");
const UserSetting = () => import(/* webpackChunkName: "main_app" */"./pages/UserSetting.vue");
const DirectDebitSetting = () => import(/* webpackChunkName: "main_app" */"./pages/DirectDebitSetting.vue");
const AutoInvestment = () => import(/* webpackChunkName: "main_app" */"./pages/AutoInvestment.vue");
const BalanceTopUpWithdraw = () => import(/* webpackChunkName: "main_app" */"./pages/balance/BalanceTopUpWithdraw.vue");
const MobileBalanceTopUpSuccess = () => import(/* webpackChunkName: "main_app" */"./pages/balance/MobileBalanceTopUpSuccess.vue");
const Notes = () => import(/* webpackChunkName: "main_app" */"./pages/investors/Notes.vue");
const BoNotes = () => import(/* webpackChunkName: "main_app" */"./pages/business_owners/Notes.vue");
const MyActivity = () => import(/* webpackChunkName: "main_app" */"./pages/MyActivity.vue");
const Notifications = () => import(/* webpackChunkName: "main_app" */"./pages/Notifications.vue");
const InvestorNoteDetailed = () => import(/* webpackChunkName: "main_app" */"./pages/investors/NoteDetailed.vue");
const BoNoteDetailed = () => import(/* webpackChunkName: "main_app" */"./pages/business_owners/NoteDetailed.vue");
const Referral = () => import(/* webpackChunkName: "main_app" */"./pages/Referral.vue");

const WiseAi = () => import(/* webpackChunkName: "main_app" */"./pages/auth/WiseAi.vue");

// there is two meta key to control the authentication status
// requiresGuest: (true) this route is for only unauthenticated user
// requiresAuth: (true) this route is for only authenticated user

let global_prefix = '';
export default [
    {
        path: global_prefix + '/',
        name: 'home',
        component: Login,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Index Page'
        }
    },
    {
        path: global_prefix + '/login',
        name: 'login',
        component: Login,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Login Page'
        }
    },
    {
        path: global_prefix + '/simulation',
        name: 'simulation',
        component: Simulation,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Simulation Page'
        }
    },
    {
        path: global_prefix + '/account/disabled',
        name: 'account_disabled',
        component: Inactive,
        props: true,
        meta: {
            layout: 'empty',
            gtm: 'Disabled Account Page'
        },
    },
    {
        path: global_prefix + '/register/:type?',
        name: 'register',
        component: Register,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Register Page'
        },
    },
    {
        path: global_prefix + '/verification',
        name: 'wiseAiVerification',
        component: WiseAi,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Wise AI Verification Page'
        }
    },
    {
        path: global_prefix + '/register/verify/:token?',
        name: 'verified_user',
        component: VerifiedUser,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Verified User Page'
        },
    },

    {
        path: global_prefix + '/privacy',
        name: 'privacy',
        component: PrivacyPolicy,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Privacy Policy Page'
        }
    },

    {
        path: global_prefix + '/consent',
        name: 'consent',
        component: Consent,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Consent Page'
        }
    },

    {
        path: global_prefix + '/issuer-disclosure/:compliant?',
        name: 'issuer_disclosure',
        component: IssuerDisclosure,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Issuer Disclosure Page'
        }
    },

    {
        path: global_prefix + '/tnc/:type?/:compliant?',
        name: 'tnc',
        component: TermsAndConditions,
        meta: {
            layout: 'guest',
            gtm: 'Terms and Conditions Page'
        }
    },

    {
        path: global_prefix + '/unsubscribe/:email?',
        name: 'unsubscribe_email',
        component: Unsubscribe,
        meta: {
            layout: 'guest',
            gtm: 'Unsubscribe Email Page'
        },
    },

    {
        path: global_prefix + '/investors/apply',
        name: 'investor_application',
        component: InvestorApplication,
        meta: {
            layout: 'empty',
            requiresAuth: true,
            gtm: 'Investor Applications Page'
        },
    },

    {
        path: global_prefix + '/business_owners/apply',
        name: 'business_owner_application',
        component: BusinessOwnerApplication,
        meta: {
            layout: 'empty',
            requiresAuth: true,
            gtm: 'Business Owner Applications Page'
        },
    },

    {
        path: global_prefix + '/password/reset/:token?',
        name: 'forgot_password',
        component: ForgotPassword,
        meta: {
            layout: 'guest',
            requiresGuest: true,
            gtm: 'Forgot Password Page'
        },
    },
    {
        path: global_prefix + '/application/review',
        name: 'under_review',
        component: ApplicationUnderReview,
        meta: {
            layout: 'empty',
            requiresAuth: true,
            gtm: 'Application Under Review Page'
        },
    },
    {
        path: global_prefix + '/application/rejected',
        name: 'application_rejected',
        component: ApplicationRejected,
        meta: {
            layout: 'empty',
            requiresAuth: true,
            gtm: 'Application Rejected Page'
        },
    },

    // investors had to top up via FPX for first time
    {
        path: global_prefix + '/topup/fpx-verify',
        name: 'fpx_verify',
        component: FpxVerification,
        meta: {
            layout: 'guest',
            requiresAuth: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'FPX Verification Page'
        },
    },

    //two factor
    {
        path: global_prefix + '/two-factor-page',
        name: 'two_factor_page',
        component: TwoFactorPage,
        meta: {
            layout: 'guest',
            requiresAuth: true,
            applicationRejected: true,
            gtm: 'Two Factor Page'
        },
    },
    //reset two-factor auth
    {
        path: global_prefix + '/two-factor/reset/:token?',
        name: 'lost_authenticator',
        component: LostAuthenticator,
        meta: {
            layout: 'guest',
            gtm: 'Reset Authenticator Page'
        },
    },
    {
        path: global_prefix + '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            layout: 'default',
            requiresAuth: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Dashboard Page'
        },
    },

    {
        path: global_prefix + '/account/settings',
        name: 'account_setting',
        component: UserSetting,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Account Settings Page'
        },
    },

    {
        path: global_prefix + '/direct-debit/settings',
        name: 'direct_debit_setting',
        component: DirectDebitSetting,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Direct Debit Settings Page'
        },
    },

/*    {
        path: global_prefix + '/account/settings/auto-investment',
        name: 'auto_investment',
        component: AutoInvestment,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true
        },
    }*/,

    {
        path: global_prefix + '/balance/:action?',
        name: 'balance',
        component: BalanceTopUpWithdraw,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Balance Topup Page'
        },
    },

    // public mobile balance topup success page.
    {
        path: global_prefix + '/mobile/balance/topup',
        name: 'mobile_balance_topup',
        component: MobileBalanceTopUpSuccess,
        meta :{
            layout: 'empty',
            requiresAuth: false,
            requiresApprovedApplication: false,
            applicationRejected: false,
            requiresTwoFactor: false
        }
    },

    {
        path: global_prefix + '/financing/apply',
        name: 'apply_financing',
        component: ApplyFinancing,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Financing Application Page'
        },
    },

    {
        path: global_prefix + '/notes',
        name: 'notes',
        component: Notes,
        meta: {
            layout: 'default',
            requiresAuth: true,
            /*requiresApprovedApplication: true,*/
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Notes Page'
        },
    },

    {
        path: global_prefix + '/notes/:ref_code',
        name: 'investor_notes_detailed',
        component: InvestorNoteDetailed,
        meta: {
            layout: 'default',
            requiresAuth: true,
            /*requiresApprovedApplication: true,*/
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Notes Details Page'
        },
    },

    {
        path: global_prefix + '/bo/notes',
        name: 'bo_notes',
        component: BoNotes,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Business Owner Notes Page'
        },
    },

    {
        path: global_prefix + '/my_activity',
        name: 'my_activity',
        component: MyActivity,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'My Activity Page'
        },
    },

    {
        path: global_prefix + '/smart-investment',
        name: 'auto_investment',
        component: AutoInvestment,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'Auto Investment Page'
        },
        props: true
    },

    {
        path: global_prefix + '/notifications',
        name: 'notifications',
        component: Notifications,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            gtm: 'My Notifications Page'
        },
    },

    {
        path: global_prefix + '/referral',
        name: 'referral',
        component: Referral,
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresApprovedApplication: true,
            applicationRejected: true,
            requiresTwoFactor: true,
            // onlyInvestors: true
        },
        props: true
    },

    /**
     * Not found page
     */
    {
        path: '*',
        name: 'NotFound',
        component: NotFound,
        meta: {
            layout: 'guest',
            requiresAuth: false,
            requiresApprovedApplication: false,
            gtm: 'Not Found Page'
        }
    }
];
